




























































































































































































import axios from 'axios';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Cutoverplan } from '@/interfaces/Cutoverplan';
import { Module } from '@/interfaces/Module';
import { Step } from '@/interfaces/Step';
import StepIdTooltip from '@/components/Steps/StepIdTooltip.vue';
import { StepRequiresStep } from '@/interfaces/StepRequiresStep';
import { Attribute } from '@/interfaces/Attribute';
import env from '../../env';

type Difference = {
  cutoverplan: Cutoverplan;
  module: Module;
  step: Step;
  blueprint: Step;
};
type MissingStep = {
  cutoverplan: Cutoverplan;
  module: Module;
  step: Step;
};

@Component({
  components: {
    StepIdTooltip
  }
})
export default class CheckDiffDialog extends Vue {
  @Prop()
  wave_id!: number;

  differences: Difference[] = [];

  dialog = false;

  getStepDifferences(difference: Difference) {
    return difference.step.requires.filter(
      (requriement) =>
        !difference.blueprint.requires.find(
          (req: StepRequiresStep) =>
            req.depending_id === requriement.depending_id && req.hidden === requriement.hidden
        )
    );
  }

  getBluerpintDifferences(difference: Difference) {
    return difference.blueprint.requires.filter(
      (requriement) =>
        !difference.step.requires.find(
          (req: StepRequiresStep) =>
            req.depending_id === requriement.depending_id && req.hidden === requriement.hidden
        )
    );
  }

  getBlueprintAttributeDifferences(difference: Difference): Attribute[] {
    return difference.blueprint.attributes.filter(
      (attribute: Attribute) =>
        !difference.step.attributes.find((att: Attribute) => att.id === attribute.blueprint_id)
    );
  }

  private missingSteps: MissingStep[] = [];

  async checkRelations(e: Event) {
    e.stopPropagation();
    const { data: differences } = await axios.get(
      `${env.backend_url}/check-relations/${this.wave_id}`
    );
    this.differences = differences.diffs;
    this.missingSteps = differences.missingSteps;
    this.dialog = true;
  }
}
